"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.historyPropTypes = exports.locationPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const locationPropTypes = {
  pathname: _propTypes.default.string.isRequired,
  search: _propTypes.default.string.isRequired,
  hash: _propTypes.default.string.isRequired,
  state: _propTypes.default.any,
  key: _propTypes.default.string
};
exports.locationPropTypes = locationPropTypes;
const historyPropTypes = {
  length: _propTypes.default.number.isRequired,
  action: _propTypes.default.string.isRequired,
  location: _propTypes.default.shape(locationPropTypes).isRequired,
  index: _propTypes.default.number,
  entries: _propTypes.default.arrayOf(_propTypes.default.shape(locationPropTypes)),
  createHref: _propTypes.default.func.isRequired,
  push: _propTypes.default.func.isRequired,
  replace: _propTypes.default.func.isRequired,
  go: _propTypes.default.func.isRequired,
  goBack: _propTypes.default.func.isRequired,
  goForward: _propTypes.default.func.isRequired,
  canGo: _propTypes.default.func,
  block: _propTypes.default.func.isRequired,
  listen: _propTypes.default.func.isRequired
};
exports.historyPropTypes = historyPropTypes;